export default "__VITE_ASSET__KKEf_kNY__"